export default __webpack_public_path__ + "static/media/fsk-11-b.83e70448.jpg";